/**
 * Report History Component
 * Thin component - all logic delegated to useReportHistory hook
 */
import Paper from '@/components/Paper'
import { Typogaphy } from 'vnetwork-ui'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import SubHeaders from '@/components/Headers/SubHeaders'
import { RefreshCw, History } from 'lucide-react'
import type { ReportWAFTask } from '../../types/response'
import { useReportHistory } from '../../hooks/use-report-history'
import BoundServicesBlock from '../shared/BoundServicesBlock'

const ReportHistory = () => {
    const {
        reportUuid,
        customerName,
        customerId,
        tasks,
        pagination,
        params,
        stateComponent,
        refetch,
        columns,
        actions,
        handlePageChange,
        handlePageSizeChange,
        t,
    } = useReportHistory()

    return (
        <>
            <SubHeaders
                breadcrumbs={[
                    { path: '/technical', title: 'Technical' },
                    { path: '/technical/report', title: t('breadcrumb.list') },
                    {
                        path: `/technical/report/${reportUuid}/history`,
                        title: customerName
                            ? `${customerName} — ${t('breadcrumb.history')}`
                            : t('breadcrumb.history'),
                    },
                ]}
                actions={[
                    {
                        label: t('history.refresh'),
                        icon: <RefreshCw className="w-4 h-4" />,
                        onClick: () => refetch(),
                    },
                ]}
            />
            <BoundServicesBlock customerId={customerId} />
            <Paper className="p-4 my-2">
                <div className="flex items-center gap-2 mb-4">
                    <History className="w-4 h-4" />
                    <Typogaphy className="text-sm font-semibold">
                        {t('history.title')}
                    </Typogaphy>
                    {customerName && (
                        <span className="text-sm text-muted-foreground">
                            — {customerName}
                        </span>
                    )}
                </div>
                {stateComponent || (
                    <DataTableCustomized<ReportWAFTask>
                        columns={columns}
                        rows={tasks}
                        rowKey={(row) => String(row.id)}
                        size="small"
                        actions={actions}
                        pagination={{
                            page: params.page,
                            pageSize: params.page_size,
                            total: pagination?.total || 0,
                            onPageChange: handlePageChange,
                            onPageSizeChange: handlePageSizeChange,
                            pageSizeOptions: [10, 20, 50, 100],
                        }}
                    />
                )}
            </Paper>
        </>
    )
}

export default ReportHistory
